import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import MainLayout from "@/layouts/MainLayout"
import { useTranslation } from "@zestia/gatsby-plugin-react-i18next"

const PartnerOfferTemplate = ({
  title,
  description,
  descriptionInstructions,
  discountCode,
  image,
  children,
  buttonLink,
  buttonText,
  altText,
}) => {
  const { t } = useTranslation()

  return (
    <MainLayout className="bg-grey pt-12 pb-12">
      <div className="partner-discount-page container-fluid col-xs-12 col-lg-10">
        <Link
          to="/partners/offers"
          className="text-link text-link--arrow-before mb-10"
        >
          {t("partners-offers.backLink")}
        </Link>
        <div className="partner-discount-container">
          <div className="partner-discount-image">
            <GatsbyImage image={image} alt={altText} />
          </div>
          <div className="partner-discount-details">
            <h1 className="h3">{t(title)}</h1>
            <p>{t(description)}</p>
            {descriptionInstructions && (
              <ul>
                {Object.entries(descriptionInstructions).map(([key, value]) => (
                  <li key={key}>{value}</li>
                ))}
              </ul>
            )}
            {discountCode && (
              <div className="partner-discount-box">{discountCode}</div>
            )}
            {children && children}
            <a
              href={buttonLink}
              className="btn "
              target="_blank"
              rel="noopener"
            >
              {t(buttonText)}
            </a>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default PartnerOfferTemplate
